interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, description, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-primary-500 font-medium">
          <span className="w-6 h-px bg-primary-500" />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">{title}</h2>
      {description && <p className="mt-3 text-sm md:text-base leading-7 text-foreground-500">{description}</p>}
    </div>
  );
}